import React from 'react';

interface SkillsSectionProps {
  hardSkills: Array<{
    skill: {
      name: string;
      type: string;
    };
  }>;
}

const SkillsSection: React.FC<SkillsSectionProps> = ({ hardSkills }) => {
  return (
    <div className="skills-grid">
      {hardSkills.map((skillItem: any, index: number) => (
        <span key={index} className="skill-tag">
          {skillItem.skill.name}
        </span>
      ))}
    </div>
  );
};

export default SkillsSection;